module.exports = __webpack_public_path__ + "img/thumb-wypedzeni-z-raju.jpg";